import type { PopupLayout } from '../types';

export function getDirectionBar(layout: PopupLayout) {
  return checkIsBar(layout) ? 'row' : 'column';
}

export function checkIsBar(layout: PopupLayout) {
  return ['topBar', 'bottomBar'].includes(layout);
}

export function checkIsPane(layout: PopupLayout) {
  return ['leftPane', 'rightPane'].includes(layout);
}

export function checkIsSlide(layout: PopupLayout) {
  return ['leftSlideIn', 'rightSlideIn'].includes(layout);
}
